$(document).on("turbo:load turbo:render", () => {
    const $registrationForm: JQuery = $("form.register").not(".change-email");
    if ($registrationForm.length) {

        // * fields * //
        const $submitButton: JQuery = $("input[type='submit']");
        const $email: JQuery = $registrationForm.find('#user_email');
        const $oldPassword: JQuery = $registrationForm.find('#user_current_password');
        const $password: JQuery = $registrationForm.find('#user_password');
        const $password_confirmation: JQuery = $registrationForm.find('#user_password_confirmation');
        const registrationFields = [$email, $password];
        const resetFields = [$password];
        const allFields = [$email, $password, $password_confirmation];

        // * messages * //
        let $numberMessage = $registrationForm.find('.number-valid-password-message');
        let $characterMessage = $registrationForm.find('.special-character-valid-password-message');
        let $caseMessage = $registrationForm.find('.uppercase-lowercase-valid-password-message');
        let $lengthMessage = $registrationForm.find('.length-valid-password-message');

        // * validators * //
        const caseValidator: RegExp = /(?=.*[a-z])(?=.*[A-Z])/;
        const characterValidator: RegExp = /[!@#$%^&()*]/;
        const numberValidator: RegExp = /[0-9]/;
        const passwordMin: number = 8;
        const passwordValidator: RegExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&()*]).{8,}/;
        const emailValidator: RegExp = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

        $submitButton.attr('disabled', 'true');

        $.extend($email, {
            validator: emailValidator,
            validate: function () {
                if (this.val != '') {
                    return this.validator.test(this.val());
                } else return false
            }
        });
        // $.extend($oldPassword, {
        //     validator: passwordValidator,
        //     validate: function () {
        //         if (this.val != '') {
        //             return this.validator.test(this.val());
        //         } else return false
        //     }
        // });
        $.extend($password, {
            validator: passwordValidator,
            validate: function () {
                if (this.val != '') {
                    return this.validator.test(this.val());
                } else return false
            }
        });
        $.extend($password_confirmation, {
            validate: function (field) {
                let value: string;
                if (field.val() != '' && this.val() != '') {
                    value = field.val();
                    return (value == this.val()) && (this.val().length == field.val().length);
                } else return false
            }
        });


        allFields.forEach(($obj) => {
            if ($obj.length) {
                let numFieldsToCheck: number = 0;
                if ($obj.closest('body').is('.passwords.edit, .passwords.update, .password_expired.show, .password_expired.update, .registrations.edit_password, .registrations.update')) {
                    numFieldsToCheck = 2;
                } else numFieldsToCheck = 3;
                $obj.on('input', (event) => {
                    if (areRegistrationFieldsValid(registrationFields, $password_confirmation, numFieldsToCheck)) {
                        $submitButton.prop('disabled', false);
                        $submitButton.removeClass('brown');
                        $submitButton.addClass('green');

                    } else {
                        $submitButton.attr('disabled', 'true');
                        $submitButton.removeClass('green');
                        $submitButton.addClass('brown');


                    }
                });
            }
        });

        $password.on('input', (event) => {
            const value: string = $(event.target).val().toString();
            if (caseValidator.test(value)) {
                turnOnCheck($caseMessage)
            } else {
                turnOffCheck($caseMessage)
            }

            if (characterValidator.test(value)) {
                turnOnCheck($characterMessage)
            } else {
                turnOffCheck($characterMessage)
            }

            if (numberValidator.test(value)) {
                turnOnCheck($numberMessage)
            } else {
                turnOffCheck($numberMessage)
            }

            if (value.length >= passwordMin) {
                turnOnCheck($lengthMessage)
            } else {
                turnOffCheck($lengthMessage)
            }

            function turnOnCheck(message) {
                message.addClass('valid');
                message.find('span').addClass('circle-check-green');
                message.find('span').removeClass('circle-gray')
            }

            function turnOffCheck(message) {
                message.removeClass('valid');
                message.find('span').addClass('circle-gray');
                message.find('span').removeClass('circle-check-green')
            }


            function isPasswordValid(value) {
                return (value.match(caseValidator) && value.match(characterValidator) && value.match(numberValidator) && value.length >= passwordMin)
            }
        });

        function areRegistrationFieldsValid(fields, confirmation, num_fields) {
            let count = 0;
            let goal = num_fields;
            fields.forEach((field) => {
                if (field.validate()) {
                    field.closest('div.field').addClass('valid-field');
                    count++;
                } else {
                    field.closest('div.field').removeClass('valid-field');
                }
            });
            if (confirmation.validate($password)) {
                confirmation.closest('div.field').addClass('valid-field');
                count++;
            } else {
                confirmation.closest('div.field').removeClass('valid-field');
            }
            if (count == goal) return true;
        }

    }

});